import { createSelector } from 'reselect';
import { getWorkOrderManagement } from './getWorkOrderManagement';

const getClockOutFlowOpen = createSelector(
  [getWorkOrderManagement],
  (workOrderManagement) => {
    return workOrderManagement.clockOutFlowOpen;
  }
);

export { getClockOutFlowOpen };
